module.exports = __webpack_public_path__ + "staticcomp/img/top.6f569ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/13/top.jpg
// module id = 2SPg
// module chunks = 39